import styled from 'styled-components';

const EndGameOptionsStyled = styled.section`
  align-items: center;
  bottom: -1px;
  border-radius: 0 0 10px 10px;
  display: flex;
  justify-content: center;
  overflow: hidden;
  position: absolute;
  width: 100%;
`;

export default EndGameOptionsStyled;



// WEBPACK FOOTER //
// ./src/components/molecules/EndGameOptions/EndGameOptions.styled.js